import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import { type FC, useCallback } from 'react'
import { useIntl } from 'react-intl'

import {
  ProductSearchRefinementCheckbox,
  type ProductSearchRefinementCheckboxProps,
} from '../ProductSearchRefinementCheckbox'

const transformItems = (
  items: RefinementListItem[],
  intl: ReturnType<typeof useIntl>,
): (RefinementListItem & { labelPrefix?: string })[] => {
  // in fock only the now option is being displayed, the rest are ignored
  const nowOption = items.find((item) => item.label === 'sameday_nextday')
  if (nowOption) {
    return [
      {
        ...nowOption,
        label: intl.formatMessage({
          id: 'general.label.filterNow',
        }),
        labelPrefix: 'Now!',
      },
    ]
  }

  return []
}

type ProductSearchRefinementShippingOptionsProps = Omit<
  ProductSearchRefinementCheckboxProps,
  'transformItems'
>

export const ProductSearchRefinementShippingOptions: FC<
  ProductSearchRefinementShippingOptionsProps
> = (props) => {
  const intl = useIntl()

  const memoizedTransformItems = useCallback(
    (items: RefinementListItem[]) => transformItems(items, intl),
    [intl],
  )

  return (
    <ProductSearchRefinementCheckbox
      {...props}
      transformItems={memoizedTransformItems}
    />
  )
}
